import PropTypes from "prop-types";
import Router from "next/router";

export default function handleTermChoice(
  handleFilterUpdate,
  href,
  onClickQueryType,
  termObject,
  mobileOpen,
  options = {}
) {
  const shallow = false; //onClickQueryType === "custom";

  const isReset = onClickQueryType === "reset";
  // If we haven't shallow rerouted, don't update the query

  handleFilterUpdate();
  console.log("Routing to ", href, { shallow, onClickQueryType });
  Router.push(href, undefined, { shallow });

  // shallow was true plus was appending onto href
}

handleTermChoice.propTypes = {
  handleFilterUpdate: PropTypes.func.isRequired,
  href: PropTypes.string.isRequired,
  onClickQueryType: PropTypes.string,
  filters: PropTypes.object,
};
